import { useState, useEffect } from "react";
import axios from "axios";
import { ReactSession } from "react-client-session";
import config from "../global/config";

export const usePermissions = () => {
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const api = axios.create({
          baseURL: config.apiUrl,
        });

        // Add token to requests
        api.interceptors.request.use(
          (config) => {
            const token = localStorage.getItem("token");
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => {
            return Promise.reject(error);
          }
        );

        const response = await api.get("profile.php");
        const permissionsMap = {};

        // Transform the permissions array into a map for easier access
        // Check if response.data is an array
        if (Array.isArray(response.data)) {
          response.data.forEach((permission) => {
            permissionsMap[permission.page] = {
              visibility:
                permission.visibility === "1" || permission.visibility === 1,
              canAdd: permission.op_add === "1" || permission.op_add === 1,
              canEdit: permission.op_edit === "1" || permission.op_edit === 1,
              canDelete:
                permission.op_delete === "1" || permission.op_delete === 1,
            };
          });
        } else {
          console.error("Expected array of permissions, got:", response.data);
        }

        // console.log("Processed permissions:", permissionsMap);
        setPermissions(permissionsMap);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        // If there's an error, assume no permissions
        setPermissions({});
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  const hasPermission = (page, operation = "visibility") => {
    const userRole = ReactSession.get("role");

    // Admin has all permissions
    if (userRole === "admin") {
      return true;
    }

    const pagePermissions = permissions[page];
    if (!pagePermissions) {
      return false;
    }

    switch (operation) {
      case "add":
        return pagePermissions.canAdd;
      case "edit":
        return pagePermissions.canEdit;
      case "delete":
        return pagePermissions.canDelete;
      case "visibility":
      default:
        return pagePermissions.visibility;
    }
  };

  return { permissions, hasPermission, loading };
};
